export default "__VITE_ASSET__C$2_MA1n__"